<div class="qf-wrapper qf-wrapper--recommendation">
  <div class="qf-grid">
    <div
      *ngFor="let group of groups"
      class="qf-card"
      [class.qf-card--active]="isGroupActive(group)"
      (click)="onGroupClick(group)"
    >
      <!-- Card header -->
      <div class="qf-card__header">
        <h3 class="qf-card__title">
          <!-- Increase icon -->
          <svg *ngIf="group.icon === 'increase'" class="qf-icon qf-icon--increase" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
            <polyline points="16 7 22 7 22 13"></polyline>
          </svg>
          <!-- Decrease icon -->
          <svg *ngIf="group.icon === 'decrease'" class="qf-icon qf-icon--decrease" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="22 17 13.5 8.5 8.5 13.5 2 7"></polyline>
            <polyline points="16 17 22 17 22 11"></polyline>
          </svg>
          <!-- Maintain icon -->
          <svg *ngIf="group.icon === 'maintain'" class="qf-icon qf-icon--maintain" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
          {{ group.label }}
        </h3>
        <span *ngIf="!loading" class="qf-card__total">{{ getGroupTotal(group) }}</span>
        <span *ngIf="loading" class="qf-skeleton qf-skeleton--total"></span>
      </div>

      <p class="qf-card__subtitle">{{ group.subtitle }}</p>

      <!-- Chips -->
      <div class="qf-chip-list">
        <div
          *ngFor="let chip of group.chips"
          class="qf-chip-row"
          [class.qf-chip-row--active]="isChipActive(chip.state)"
          (click)="onChipClick($event, chip.state)"
        >
          <app-item-pricing-inventory-health-chip
            [state]="chip.state"
            [sublabel]="chip.label ? '(' + chip.label + ')' : undefined"
            size="md"
          ></app-item-pricing-inventory-health-chip>
          <span *ngIf="!loading" class="qf-chip-row__count ml-auto">{{ getChipCount(chip.state) }} items</span>
          <span *ngIf="loading" class="qf-skeleton qf-skeleton--count ml-auto"></span>
        </div>
      </div>
    </div>
  </div>
</div>
